'use strict';

angular.module('webAgro1App').directive('agroBackgroundImage', function() {
  return function(scope, element, attrs){
    attrs.$observe('agroBackgroundImage', function(value) {
      element.css({
        'background-image': 'url(' + value +')',
        'background-size' : 'cover',
        '-webkit-background-size' : 'cover',
        '-moz-background-size' : 'cover',
        '-o-background-size': 'cover',
        'background-repeat' : 'no-repeat',
        'background-position' : 'center'
      });
    });
    attrs.$observe('agroBackgroundImageHeight', function(value) {
      element.css({
        'height' : value
      });
    });
  };
});